import { render, staticRenderFns } from "./Rewards.vue?vue&type=template&id=1b446256&scoped=true&"
import script from "./Rewards.vue?vue&type=script&lang=js&"
export * from "./Rewards.vue?vue&type=script&lang=js&"
import style0 from "./Rewards.vue?vue&type=style&index=0&id=1b446256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b446256",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VContainer,VDataTable,VRow,VTextField})
